import { menu, site, item, category, choice, choiceSet } from '@/api';

export default {
    name: 'choice',
    namespaced: true,
    state: {
        choiceSet: {},
        choiceList: [],
        choiceSetList: [],
        siteList: [],
        itemList: [],
        catetoryList: [],
        menuList: [],
        majorList: []
    },
    mutations: {
        ['CHOICE_SET_ID_CHANGE'](state, obj) {
            state.choiceSet = obj;
        },
        ['CHOICE_LIST'](state, list){
            state.choiceList = list;
        },
        ['CHOICE_SET_LIST'](state, list){
            state.choiceSetList = list;
        },
        ['SITE_LIST'](state, list){
            state.siteList = list;
        },
        ['ITEM_LIST'](state, list){
            state.itemList = list;
        },
        ['CATETORY_LIST'](state, list){
            state.catetoryList = list;
        },
        ['MENU_LIST'](state, list){
            state.menuList = list;
        },
        ['MAJOR_LIST'](state, list){
            state.majorList = list;
        }
    },
    actions: {
        getChoiceList({commit, state, rootState}, params){
            choice.choiceList({
                company_code: rootState.common.company_code,
                page: 1,
                page_size: 12
            }).then( res => {
                if(res.code == 0) {
                    commit('CHOICE_LIST', res.data.list);
                }
            })
        },
        getChoiceSetList({commit, state, rootState}, params){
            choiceSet.choiceSetList({
                company_code: rootState.common.company_code,
                page: 1,
                page_size: 12
            }).then( res => {
                if(res.code == 0) {
                    commit('CHOICE_SET_LIST', res.data.list);
                }
            })
        },
        getSiteList({commit, state, rootState}, params){
            site.getSiteList({
                company_code: rootState.common.company_code,
                page: 1,
                page_size: 12
            }).then( res => {
                if(res.code == 0) {
                    commit('SITE_LIST', res.data);
                }
            })
        },
        getItemList({commit, state, rootState}, params){
            item.getItemList({
                company_code: rootState.common.company_code,
                page: 1,
                page_size: 12
            }).then( res => {
                if(res.code == 0) {
                    commit('ITEM_LIST', res.data.list);
                }
            })
        },
        getCatetoryList({commit, state, rootState}, params){
            category.getCategoryList({
                company_code: rootState.common.company_code,
                page: 1,
                page_size: 12
            }).then( res => {
                if(res.code == 0) {
                    commit('CATETORY_LIST', res.data.list);
                }
            })
        },
        getMenuList({commit, state, rootState}, params){
            menu.getMenuList({
                company_code: rootState.common.company_code,
                page: 1,
                page_size: 12
            }).then( res => {
                if(res.code == 0) {
                    commit('MENU_LIST', res.data.list);
                }
            })
        },
        getMajorCode({ commit}, params){
            site.getValidSiteCode().then(res => {
                if(res.code == 0) {
                    commit('MAJOR_LIST', res.data);
                }
            })
        },
        initSelectList({commit, dispatch}){
            dispatch('getChoiceList');
            dispatch('getChoiceSetList');
            dispatch('getSiteList');
            dispatch('getItemList');
            dispatch('getCatetoryList');
            dispatch('getMenuList');
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/choice.js